import { Button, Stack, Typography } from '@mui/material';
import { ATSVacanciesModalTestIds } from 'data-testids/ATS';
import { useFormContext } from 'react-hook-form';
import { IncrementDecrementContainer, UnsureVacancyInfoText } from '../styles';

export const VacancyIncrementor = ({
  field,
  onBeforeChange,
  isDisabled,
  type,
}: {
  field: string;
  onBeforeChange?: () => string;
  isDisabled?: boolean;
  type: 'school' | 'district';
}) => {
  const { watch, setValue } = useFormContext();
  const currentRaw = watch(field);
  const current = currentRaw != null && !isNaN(currentRaw) ? currentRaw : 0;

  const handleDecrement = () => {
    const fieldToUse = onBeforeChange ? onBeforeChange() : field;
    const currentValue = watch(fieldToUse) ?? 0;
    const newTotal = Math.max(0, currentValue - 1);
    setValue(fieldToUse, newTotal);
  };

  const handleIncrement = () => {
    const fieldToUse = onBeforeChange ? onBeforeChange() : field;
    const currentValue = watch(fieldToUse) ?? 0;
    const newTotal = currentValue + 1;
    setValue(fieldToUse, newTotal);
  };

  const getVacancyCount = () => {
    if (!current || current == 0) return 'Unsure';

    return current;
  };

  return (
    <Stack direction="row" alignItems="center">
      <IncrementDecrementContainer>
        <Button
          data-testid={ATSVacanciesModalTestIds.VACANCY_INCREMENTOR_DECREMENT_BUTTON}
          sx={{ minWidth: '20%' }}
          onClick={handleDecrement}
          disabled={current === 0 || isDisabled}
        >
          -
        </Button>
        <Typography data-testid={ATSVacanciesModalTestIds.DISTRICT_VACANCY_COUNT}>
          {getVacancyCount()}
        </Typography>
        <Button
          data-testid={ATSVacanciesModalTestIds.VACANCY_INCREMENTOR_INCREMENT_BUTTON}
          sx={{ minWidth: '20%' }}
          onClick={handleIncrement}
          disabled={isDisabled}
        >
          +
        </Button>
      </IncrementDecrementContainer>
      {getVacancyCount() === 'Unsure' && type === 'school' && (
        <UnsureVacancyInfoText>This site will not show up on the job board</UnsureVacancyInfoText>
      )}
    </Stack>
  );
};
